module.exports = __webpack_public_path__ + "static/media/29EUNOG9.df0c1420.jpg";